// 选片后台 API（独立于 delivery）：创建/列举/更新/删除选片链接，列举/删除选片结果。
// 单独成文件以避免与 adminAuth 循环依赖（与 deliveryAdminApi 同思路）。
import { getDeliveryApiBase } from "./deliveryApi";
import { getAdminToken } from "./adminAuth";

export const SUBMISSIONS_DEFAULT_PAGE_SIZE = 20;
export const SUBMISSIONS_MAX_PAGE_SIZE = 50;

function apiBase() {
    const base = getDeliveryApiBase();
    if (!base) {
        throw new Error("MISSING_API");
    }
    return base;
}

async function requestJson(path, { method = "GET", body } = {}) {
    const token = getAdminToken();
    const response = await fetch(`${apiBase()}${path}`, {
        method,
        headers: {
            ...(body ? { "Content-Type": "application/json" } : {}),
            Authorization: `Bearer ${token}`,
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    if (!response.ok) {
        const payload = await response.json().catch(() => ({}));
        const error = new Error(payload.error?.message || "REQUEST_FAILED");
        error.status = response.status;
        throw error;
    }
    return response.json().catch(() => ({}));
}

function buildSubmissionsQuery({
    linkId,
    albumPath,
    q,
    from,
    to,
    page = 1,
    pageSize = SUBMISSIONS_DEFAULT_PAGE_SIZE,
} = {}) {
    const params = new URLSearchParams();
    if (linkId) {
        params.set("linkId", linkId);
    }
    if (albumPath) {
        params.set("albumPath", albumPath);
    }
    if (q) {
        params.set("q", q);
    }
    if (from != null) {
        params.set("from", String(from));
    }
    if (to != null) {
        params.set("to", String(to));
    }
    params.set("page", String(page));
    params.set("pageSize", String(pageSize));
    const query = params.toString();
    return query ? `?${query}` : "";
}

export async function createSelection({
    albumPath,
    albumName,
    expiry,
    consent,
    downloadAllType,
    downloadAllToken,
    archiveMarkdown,
}) {
    const data = await requestJson("/api/selection/create", {
        method: "POST",
        body: {
            albumPath,
            albumName,
            expiry,
            consent,
            downloadAllType,
            downloadAllToken,
            archiveMarkdown,
        },
    });
    return data.selection;
}

export async function updateSelection(
    id,
    {
        albumPath,
        albumName,
        expiry,
        consent,
        downloadAllType,
        downloadAllToken,
        archiveMarkdown,
    }
) {
    await requestJson(`/api/selection/${encodeURIComponent(id)}`, {
        method: "PUT",
        body: {
            albumPath,
            albumName,
            expiry,
            consent,
            downloadAllType,
            downloadAllToken,
            archiveMarkdown,
        },
    });
    return true;
}

export async function listSelections() {
    const data = await requestJson("/api/selections");
    return data.selections || [];
}

export async function deleteSelection(id) {
    await requestJson(`/api/selection/${encodeURIComponent(id)}`, { method: "DELETE" });
    return true;
}

export async function listSubmissions(options = {}) {
    const query = buildSubmissionsQuery(options);
    const data = await requestJson(`/api/selection/submissions${query}`);
    return {
        submissions: data.submissions || [],
        page: data.page || options.page || 1,
        pageSize: data.pageSize || options.pageSize || SUBMISSIONS_DEFAULT_PAGE_SIZE,
        hasMore: Boolean(data.hasMore),
    };
}

export async function getSubmission(id) {
    const data = await requestJson(`/api/selection/submission/${encodeURIComponent(id)}`);
    return data.submission || null;
}

export async function deleteSubmission(id) {
    await requestJson(`/api/selection/submission/${encodeURIComponent(id)}`, { method: "DELETE" });
    return true;
}
